// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"GameProjectList_wrapper_q6j55","tableHeader":"GameProjectList_tableHeader_Ggkri","tableBody":"GameProjectList_tableBody_3lJ39","header":"GameProjectList_header_V5_3a"};